<template>
  <client-billing-layout>
    <div v-if="loading" class="d-flex justify-content-center">
      <b-spinner></b-spinner>
    </div>
    <b-tabs v-else content-class="py-3">
      <b-tab
        v-for="(tab, index) in tabs"
        :key="tab.key"
        :title="tab.title"
        :active="selectedTab === index"
        @click="selectTab(index)">
        <b-container fluid>
          <component
            v-if="selectedTab === index"
            :is="tab.component"
            :ref="tab.key"
            :client="client"
            :information="information"/>
        </b-container>
      </b-tab>
    </b-tabs>
  </client-billing-layout>
</template>

<script>
import axios from 'axios';

import translations from '@/translations';
import ClientBillingLayout from '@/components/Financial/ClientBillingLayout.vue';
import financeService from '@/services/finance-service';
import { parseResponseError } from '@/http/parsers/parse_response';
import GeneralTab from './generalTab.vue';

const implementationInfoTranslations = translations.finance.client_configs.implementation_information;

export default {
  name: 'ImplementationInfo',
  components: {
    ClientBillingLayout,
    GeneralTab,
  },
  data() {
    return {
      translations: implementationInfoTranslations,
      loading: true,
      selectedTab: 0,
      client: {},
      information: {},
      tabs: [
        {
          key: 'general',
          title: implementationInfoTranslations.general.tab_name,
          component: 'GeneralTab',
        },
      ],
    };
  },
  async beforeMount() {
    const tab = this.$route.query?.tab || 'general';
    const tabIndex = this.tabs.findIndex(t => t.key === tab);
    if (tabIndex !== -1) this.selectedTab = tabIndex;

    const clientId = Number(this.$route.params.clientId);
    await Promise.all([
      this.fetchImplementationInfo(clientId),
      this.fetchClient(clientId),
    ]);
    this.loading = false;
  },
  methods: {
    selectTab(index) {
      this.selectedTab = index;
      // reset query params when changing tabs
      const currentRoute = this.$route;
      this.$router.replace({
        path: currentRoute.path,
        query: {
          tab: this.tabs[index].key,
        },
      }).catch(() => {});
    },
    async fetchImplementationInfo(clientId) {
      try {
        this.information = await financeService.getImplementationInfo(clientId);
      } catch (error) {
        this.$noty.error(`${this.translations.errors.fetch_implementation_info}: ${parseResponseError(error)}`);
      }
    },
    async fetchClient(clientId) {
      try {
        const response = await axios.get(`v1/clients/${clientId}`, { params: { by: 'id' } });
        this.client = response.data.client;
      } catch (error) {
        this.$noty.error(`${this.translations.errors.fetch_client}: ${parseResponseError(error)}`);
      }
    },
  },
};
</script>
